/**
 * The board a surface places — resolved in ONE place.
 *
 * A Drop can name a board two ways: the ENGAGEMENT section an operator adds
 * (the real assignment) and a legacy LEADERBOARD content block carrying
 * `ledgerBoardId`. `useDropHubData` already has to reconcile them so the same
 * board is not rendered twice; every other reader should ask here rather than
 * grow a third opinion about which one wins.
 *
 * The section wins: it is what the editor writes today, and the block is the
 * form that predates it.
 */

interface BoardBearingSection {
    engagementType?: string;
    engagementId?: string;
}

interface BoardBearingBlock {
    type?: string;
    leaderboardConfig?: { ledgerBoardId?: string };
}

export function placedBoardId(
    sections?: BoardBearingSection[],
    blocks?: BoardBearingBlock[],
): string | undefined {
    const section = sections?.find(s => s.engagementType === "LEDGER_BOARD" && s.engagementId);
    if (section?.engagementId) {
        return section.engagementId;
    }
    return blocks?.find(b => b.type === "LEADERBOARD" && b.leaderboardConfig?.ledgerBoardId)
        ?.leaderboardConfig?.ledgerBoardId;
}
